import { Component, OnDestroy, OnInit } from "@angular/core"
import { ActivatedRoute } from "@angular/router"
import { Subscription } from "rxjs"
import { ORDERED_GRADE_KEYS } from "../../../models/constants"
import { FacetingService } from "../../../services/faceting.service"

@Component({
    selector: "app-filter-by-grade",
    templateUrl: "./filter-by-grade.component.html",
    styleUrls: ["./filter-by-grade.component.scss"],
})
export class FilterByGradeComponent implements OnInit, OnDestroy {
    public options: string[] = ORDERED_GRADE_KEYS
    public selectedGrades: string[] = []
    public subscriptions: Subscription[] = []

    constructor(private route: ActivatedRoute, private facetingService: FacetingService) {}

    public ngOnInit() {
        this.subscriptions.push(
            this.route.queryParams.subscribe(() => {
                const facets = this.facetingService.getSelectedFacets(this.route)
                this.selectedGrades = []
                facets.map((facet) => {
                    if (facet.indexOf("grades:") !== -1) {
                        this.selectedGrades = facet.split(":")[1].split(",")
                    }
                })
            })
        )
    }

    public changeGrade() {
        this.facetingService.addFilter(`grades:${this.selectedGrades.join(",")}`, this.route, true)
    }

    public removeLastGrade(event) {
        if (this.selectedGrades.length === 0) {
            this.facetingService.removeFilter("grades:" + event.value, this.route)
        }
    }

    public ngOnDestroy() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }
}
